/**
 * Analytics Filters Sheet (mobile)
 * Bottom sheet containing Reporting Period and Channel filter for Analytics page.
 * Keeps header compact on mobile; all filter controls in one tappable sheet.
 */
import React from 'react';
import BottomSheet from '../BottomSheet.jsx';
import ReportingPeriodBar from '../../shared/ReportingPeriodBar.jsx';
import CompactChannelFilter from './CompactChannelFilter.jsx';

export default function AnalyticsFiltersSheet({
  isOpen,
  onClose,
  channels = [],
  selectedChannels = [],
  onChannelsChange,
}) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="Filters" disableDrag={false}>
      <div style={styles.content}>
        <section style={styles.section} aria-labelledby="analytics-period-heading">
          <h2 id="analytics-period-heading" style={styles.sectionTitle}>
            Reporting period
          </h2>
          <ReportingPeriodBar />
        </section>
        {channels.length > 0 && (
          <section style={styles.section} aria-labelledby="analytics-channel-heading">
            <h2 id="analytics-channel-heading" style={styles.sectionTitle}>
              Channel
            </h2>
            <div style={styles.channelWrap}>
              <CompactChannelFilter
                channels={channels}
                selectedChannels={selectedChannels}
                onChannelsChange={onChannelsChange}
                touchFriendly={true}
              />
            </div>
          </section>
        )}
      </div>
    </BottomSheet>
  );
}

const styles = {
  content: {
    padding: 'var(--spacing-4) 0',
    minHeight: '40vh',
  },
  section: {
    marginBottom: 'var(--spacing-6)',
  },
  sectionTitle: {
    fontSize: 'var(--font-size-sm)',
    fontWeight: 600,
    color: 'var(--color-text-secondary, #6b7280)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    margin: '0 0 var(--spacing-3) 0',
  },
  channelWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-2)',
    alignItems: 'stretch',
  },
};
